import { NoiseClassificationIcon } from 'app/views/configuration/pages/noise/noise-classifications/noise-classification-icon';
import { srOnly } from 'app/visuals/mixins/srOnly';
import { styled } from 'styled-components';

export const SelectableButtonWrapper = styled.label<{ $isLoading?: boolean }>`
  display: inline-block;
  cursor: pointer;
  cursor: ${({ $isLoading }) => $isLoading && 'not-allowed'};
  user-select: none;
`;

export const SelectableButtonInner = styled.span<{
  $textColor?: string;
  $background?: string;
  $isSelected?: boolean;
}>`
  background: ${({ theme, $background }) => $background ?? theme.colors.mono.ui04};
  border-radius: 100px;
  color: ${({ theme, $textColor }) => $textColor ?? theme.colors.mono.text02};
  padding: ${({ theme: { spacing } }) => `${spacing(0.75)}px ${spacing(1.25)}px`};
  transition: box-shadow 0.15s ease;
  display: flex;
  align-items: center;
  height: 32px;
`;

export const SelectableButtonInput = styled.input.attrs<{
  $highlightSelected?: boolean;
}>({
  type: 'checkbox',
})`
  ${srOnly}
  &:not(:disabled) ~ ${SelectableButtonInner} {
    &:hover {
      box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.mono.ui06};
    }
  }
  &:not(:disabled):focus-visible ~ ${SelectableButtonInner} {
    box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.mono.ui06};
  }
  ${({ $highlightSelected, theme }) =>
    $highlightSelected &&
    `
      &:checked ~ ${SelectableButtonInner} {
        box-shadow: 0 0 0 2px ${theme.colors.brand.brand02};
        &:hover {
          box-shadow: 0 0 0 2px ${theme.colors.brand.brand02};
        }
      }
    `}
`;

export const SelectableButtonIcon = styled(NoiseClassificationIcon)`
  max-width: 24px;
  max-height: 24px;
  margin-right: ${({ theme }) => theme.spacing()}px;
  path {
    fill: currentColor;
  }
`;

export const SelectableButtonText = styled.span`
  font-size: 1.4rem;
`;
